import * as React from "react";

export class Segment extends React.Component<{
    index: number
    time: string
}, {}> {

    render() {
        const { index, time } = this.props;

        return (
            <div className={`rj-pulse-bet__progress-period rj-pulse-bet__progress-period-${index}`}>
                {time}
            </div>
        )
    }
}